import { render } from "./ConclusionDetail.vue?vue&type=template&id=31daabf9&scoped=true"
import script from "./ConclusionDetail.vue?vue&type=script&lang=js"
export * from "./ConclusionDetail.vue?vue&type=script&lang=js"

import "./ConclusionDetail.vue?vue&type=style&index=0&id=31daabf9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31daabf9"]])

export default __exports__